import React, { FC } from 'react';

import { EmployeesTable } from './EmployeesTable';

export const SuperAdmins: FC = () => {
  return (
    <EmployeesTable
      queryKeyPrefix="fetch-super-admins"
      washHubId={undefined}
      role="super_admin"
    />
  );
};
